<template>
  <div id="csContainer">
    <div class="toolbar">
      <span>经度: </span>
      <input type="number" v-model="lon" min="1" step="1" class="form-control" style="width:100px">
      <span>经度: </span>
      <input type="number" v-model="lat" min="1" step="1" class="form-control" style="width:100px">
      <br/>
      <br/>
      <span>高度：</span>
      <input type="number" v-model="height" min="1" step="1" class="form-control" style="width:100px">
      <input type="button" value="加载模型"  class="btn btn-primary" @click="addModel()">
    </div>
  </div>
</template>


<script>
    /*eslint-disable*/
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import util from "../../components/util"
    export default {
        name: 'headMap',
        data(){
            return{
                isShow: false,
                viewer: null,
                lon: -123.0744619,
                lat:  44.0503706,
                height: 0,
                entity: null
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            init(){
              let viewer = util.getViewer("csContainer");
              this.viewer = viewer;
              var position = Cesium.Cartesian3.fromDegrees(-123.0744619, 44.0503706, 0);

              var heading = Cesium.Math.toRadians(135);
              var pitch = 0;
              var roll = 0;
              var hpr = new Cesium.HeadingPitchRoll(heading, pitch, roll);
              var orientation = Cesium.Transforms.headingPitchRollQuaternion(position, hpr);
              this.entity = viewer.entities.add({
                name : 'url',
                position : position,
                orientation : orientation,
                model : {
                  uri : "/demo/static/data/models/car.glb",
                  minimumPixelSize : 1,
                  maximumScale : 200,
                  scale:1
                }
              });
              viewer.zoomTo(viewer.entities);
            },

          cancel(){
              if(this.handler != null ){
                this.handler.destroy();
              }

          },
          addModel(){
            var viewer = this.viewer;
            // viewer.entities.removeAll();
            let self = this;
            let a = parseFloat(self.lon);
            let b = parseFloat(self.lat);
            let c = parseFloat(self.height);
            let position = Cesium.Cartesian3.fromDegrees(a, b,c);
            this.entity.position = position;
            // var heading = Cesium.Math.toRadians(135);
            // var pitch = 0;
            // var roll = 0;
            // var hpr = new Cesium.HeadingPitchRoll(heading, pitch, roll);
            // var orientation = Cesium.Transforms.headingPitchRollQuaternion(position, hpr);
            // var entity = viewer.entities.add({
            //   name : 'url',
            //   position : position,
            //   orientation : orientation,
            //   model : {
            //     uri : "/demo/static/data/models/car.glb",
            //     minimumPixelSize : 1,
            //     maximumScale : 200,
            //     scale:1
            //   }
            // });

            viewer.flyTo(this.entity);

          }

        }
    }
</script>
<style scoped>
  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
    position: relative;
  }
  .toolbar{
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    width: 360px;
    height: 100px;
    top: 10px;
    left: 10px;
    padding: 10px 15px;
    border-radius: 4px;
    border: 1px solid rgba(128,128,128,.5);
    color: #fff;
    background: rgba(0,0,0,.4);
    box-shadow: 0 3px 14px rgba(128,128,128,.5);
    z-index: 100;
  }
  .form-control{
    color: #fff;
    background-color: rgba(63,72,84,.7);
    border: none;
  }
  .btn-primary{
    color:#fff;
    background-color: rgba(32,160,255,.2);
    cursor: pointer;
    margin: 0 2px 0 2px;
    border: 1px solid #e4eaec;
    border-radius: 3px;
  }
</style>
